import CryptoJS from 'crypto-js/crypto-js';
import {db} from './firebase-services';
import {shallowEqual, useSelector} from "react-redux";
import {useEffect, useRef} from "react";
import {isMacintosh} from "../helper";
import {fabric} from "fabric";
import {saveIdea} from "./ideas";

export const KEY = "WDYT_SECRET";

export async function saveCanvasData (canvas)
{
    const data = JSON.stringify(canvas),
          currentDate = Date.now();


    try
    {
		let groupForExportingImage = new fabric.Group(canvas.getObjects(), {canvas: canvas});
		let base64 = await new Promise((resolve, reject) =>
		{
			groupForExportingImage.exportPNG(resolve);
		});
		canvas.discardActiveObject();
		groupForExportingImage._restoreObjectsState();
/*
		let div = document.createElement('div');
		document.body.append(div);
		div.style.position = 'absolute';
		div.style.zIndex = 100000000;
		div.style.top = 0;
		div.style.right = 0;
		div.style.width = '300px';
		div.style.height = '300px';
		div.style.border = '1px solid #fff';*/

		/*let img = document.createElement('img');
		img.src = base64;
		img.style.maxWidth = '98%';
		img.style.maxHeight = '98%';
		div.appendChild(img);
		return;*/

		let bytesCount = (new TextEncoder().encode(base64)).length;
		if (bytesCount > Math.pow(10, 6))
		{
			base64 = 'data:image/png;base64,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';
		}

		let idea = {
			data,
			base64,
			createDate: currentDate,
			lastUpdateDate: currentDate
		};

        const docRef = await db.collection("data").add(idea);
        const id = docRef.id;
        console.log("Document written with ID: ", id);
        const encryptedId = CryptoJS.AES.encrypt(id, KEY).toString();
        console.log(encryptedId);
        const decryptedId = CryptoJS.AES.decrypt(encryptedId, KEY).toString(CryptoJS.enc.Utf8);
        console.log(decryptedId);

        let savedData = {id, ...idea};

        return [savedData, encryptedId];
    }
    catch (e)
    {
        console.error("Error adding document: ", e);
        return null;
    }
    finally
    {

    }
}

export async function markCanvasDataAsIdea (ideaData, user)
{
	try
	{
		let docsQuery1 = db.collection("data").where('createdBy', '==', user.id),
			querySnapshot = await docsQuery1.get(),
			docsSize = querySnapshot.size,
			updatedIdea = {
				...ideaData,
				idea : true,
				createdBy : user.id,
				name : 'Untitled idea #' + (docsSize + 1)
			};

		await saveIdea(ideaData.id, updatedIdea);

		return true;
	}
	catch (e)
	{
		console.error("Error saving canvas data as idea: ", e);
		return false;
	}
	finally
	{

	}
}


export async function updateCanvasData (shareId, canvas)
{
    const data = JSON.stringify(canvas),
        currentDate = Date.now(),
        decryptedId = CryptoJS.AES.decrypt(shareId, KEY).toString(CryptoJS.enc.Utf8);

    try
    {
        await db.collection("data").doc(decryptedId).update({...data, lastUpdateDate: currentDate});
        return true;
    }
    catch (e)
    {
        console.error("Error updating document: ", e);
        return false;
    }
    finally
    {

    }
}

export async function loadCanvasData (shareId)
{
    const decryptedId = CryptoJS.AES.decrypt(shareId, KEY).toString(CryptoJS.enc.Utf8);

    try
    {
        const docRef = await db.collection("data").doc(decryptedId).get();
        return docRef.data();
    }
    catch (e)
    {
        console.error("Error reading document: ", e);
        return null;
    }
    finally
    {

    }
}

export function useShareUrl ()
{
    const shareId = useSelector(state => state.main.shareId, shallowEqual);

    if (shareId === null)
    {
        return null;
    }

    return window.location.origin + `/share/${encodeURIComponent(shareId)}`;
}

export function getKeyListener (keycodes, callback, withAlt = false, withCtrl = false, withShift = false)
{
	return (e) =>
	{
		let ctrlKey = isMacintosh() ? e.metaKey : e.ctrlKey;

		if (keycodes.indexOf(e.keyCode) !== -1 &&
			(!withAlt && !e.altKey || withAlt && e.altKey) &&
			(!withCtrl && !ctrlKey || withCtrl && ctrlKey) &&
			(!withShift && !e.shiftKey || withShift && e.shiftKey))
		{
			callback(e);
		}
	};
}

export function useEventListener (eventName, handler, element = window){

	const savedHandler = useRef();

	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);

	useEffect(
		() => {
			const isSupported = element && element.addEventListener;
			if (!isSupported) return;

			const eventListener = event => savedHandler.current(event);

			element.addEventListener(eventName, eventListener);

			return () => {
				element.removeEventListener(eventName, eventListener);
			};
		},
		[eventName, element]
	);
}
